<template>
  <div class="flex flex-col items-center justify-center w-full h-full">
    <ph-ghost v-if="type === 'default'" :size="75" :color="$helpers.getCorrectColor(themeColorHEX)" />
    <ph-heart-break v-else :size="75" :color="$helpers.getCorrectColor(themeColorHEX)" />
    <div class="pt-11 flex flex-col items-center justify-center w-full px-4 text-black">
      <t-heading tag="h2" class="font-semibold">
        {{ mainText }}
      </t-heading>
      <t-text class="text-center">
        {{ secondaryText }}
      </t-text>
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 't-empty-state',
    props: {
      /* 
          default -> No content -> 'ghost' icon and 'Oh snap!' main text
          filters/search -> No content with filters/search applied -> 'heartbreak' icon and 'Nothing to display' main text
        */
      type: {
        type: String,
        default: 'default',
        validator: v => ['default', 'filters', 'search'].indexOf(v) !== -1
      }
    },
    computed: {
      ...mapGetters(['themeColorHEX']),
      mainText() {
        return this.type === 'default' ? this.$t('components.emptyState.primaryTitle') : this.$t('components.emptyState.secondaryTitle')
      },
      secondaryText() {
        return this.type === 'default' ? this.$t('components.emptyState.primaryText') : this.$t('components.emptyState.secondaryText')
      }
    }
  }
</script>
